import Link from "next/link";
export const iconBoxes = [
  {
    iconClass: "icon-shipping-1",
    title: "Free Shipping",
    description: "Free shipping over order $120",
  },
  {
    iconClass: "icon-payment-1",
    title: "Flexible Payment",
    description: "Pay with Multiple Credit Cards",
  },
  {
    iconClass: "icon-return-1",
    title: "14 Day Returns",
    description: "Within 30 days for an exchange",
  },
];

export const iconBoxData = [
 
];

export const iconBoxes2 = [
  {
    iconClass: "icon-shipping-1",
    title: "Fast & free shipping",
    description:
      "Every single order ships for free. No minimums, no tiers, no fine print whatsoever.",
  },
  {
    iconClass: "icon-payment-1",
    title: "Modular, easy-to-move design",
    description:
      "Our innovative modular design is driven by the belief that furniture should fit this home, and the next one.",
  },
  {
    iconClass: "icon-return-1",
    title: "Durable, premium materials",
    description:
      "We use materials like sustainably-forested wood, strengthened steel hardware, and top-grain Italian leather.",
  },
  {
    iconClass: "icon-shipping-1",
    title: "Fast & free shipping",
    description:
      "Every single order ships for free. No minimums, no tiers, no fine print whatsoever.",
  },
  {
    iconClass: "icon-payment-1",
    title: "Modular, easy-to-move design",
    description:
      "Our innovative modular design is driven by the belief that furniture should fit this home, and the next one.",
  },
  {
    iconClass: "icon-return-1",
    title: "Durable, premium materials",
    description:
      "We use materials like sustainably-forested wood, strengthened steel hardware, and top-grain Italian leather.",
  },
];

export const slides = [
  {
    iconClass: "icon-shipping",
    title: "Free Shipping on Orders Over $120",
    justifyClass: "justify-content-end",
  },
  {
    iconClass: "icon-trial",
    title: "100-days risk-free trial",
    justifyClass: "justify-content-center",
  },
  {
    iconClass: "icon-warranty",
    title: "Free 4-years warranty",
    justifyClass: "",
  },

  {
    iconClass: "icon-trial",
    title: "100-days risk-free trial",
    justifyClass: "justify-content-center",
  },
];

export const iconBoxes3 = [
  {
    iconClass: "icon-shipping",
    title: "Free Shipping",
    description: "Free shipping over order $120",
  },
  {
    iconClass: "icon-payment fs-22",
    title: "Flexible Payment",
    description: "Pay with Multiple Credit Cards",
  },
  {
    iconClass: "icon-return fs-20",
    title: "14 Day Returns",
    description: "Within 30 days for an exchange",
  },
  {
    iconClass: "icon-suport",
    title: "Premium Support",
    description: "Outstanding premium support",
  },

  {
    iconClass: "icon-return fs-20",
    title: "14 Day Returns",
    description: "Within 30 days for an exchange",
  },
];

export const iconBoxSlides = [
  {
    title: "Huge Selection",
    desc: (
      <>
        With over 1,600 fun sock styles, our{" "}
        <Link href={`/shop-default`} className="text-decoration-underline">
          sock
        </Link>
        <br />
        <Link href="/shop-default" className="text-decoration-underline">
          selection
        </Link>{" "}
        is unmatched!
      </>
    ),
  },
  {
    title: "Perfect Gift",
    desc: (
      <>
        Every order arrives wrapped in a <br />
        cute friendly mailer to look like a present
      </>
    ),
  },
  {
    title: "Pay Your Way",
    desc: (
      <>
        We accept all major credit cards and offer
        <br />
        installments through Shop Pay.
      </>
    ),
  },
  {
    title: "Perfect Gift",
    desc: (
      <>
        Every order arrives wrapped in a <br />
        cute friendly mailer to look like a present
      </>
    ),
  },
];

export const recentCollectionSlides = [
  {
    imgSrc: "/images/collections/cls-sock.jpg",
    alt: "collection-img",
    width: 800,
    height: 792,
    wowDelay: "0s",
    subheading: "UP TO 30% OFF",
    heading: "Beachwear on Sale",
    btnClass:
      "tf-btn btn-color-2 style-3 text-uppercase rounded-0 fw-6 animate-hover-btn letter-2",
  },
  {
    imgSrc: "/images/collections/cls-sock2.jpg",
    alt: "collection-img",
    width: 800,
    height: 792,
    wowDelay: "0s",
    subheading: "UP TO 30% OFF",
    heading: "Athleisure Wear",
    btnClass:
      "tf-btn btn-color-3 text-uppercase style-3 rounded-0 fw-6 animate-hover-btn letter-2",
  },
  {
    imgSrc: "/images/collections/cls-sock.jpg",
    alt: "collection-img",
    width: 800,
    height: 792,
    wowDelay: "0s",
    subheading: "UP TO 30% OFF",
    heading: "Beachwear on Sale",
    btnClass:
      "tf-btn btn-color-2 style-3 text-uppercase rounded-0 fw-6 animate-hover-btn letter-2",
  },
  {
    imgSrc: "/images/collections/cls-sock2.jpg",
    alt: "collection-img",
    width: 800,
    height: 792,
    wowDelay: "0s",
    subheading: "UP TO 30% OFF",
    heading: "Athleisure Wear",
    btnClass:
      "tf-btn btn-color-3 text-uppercase style-3 rounded-0 fw-6 animate-hover-btn letter-2",
  },
];

export const iconBoxes4 = [
  {
    iconClass: "icon-materials",
    title: "High-Quality Materials",
    description:
      "Crafted with precision and excellence, our activewear is meticulously engineered using premium materials to ensure unmatched comfort and durability.",
  },
  {
    iconClass: "icon-design",
    title: "Laconic Design",
    description:
      "Simplicity refined. Our activewear embodies the essence of minimalistic design, delivering effortless style that speaks volumes.",
  },
  {
    iconClass: "icon-sizes",
    title: "Various Sizes",
    description:
      "Designed for every body and anyone, our activewear embraces diversity with a wide range of sizes and shapes, celebrating the beauty of individuality.",
  },
  {
    iconClass: "icon-design",
    title: "Laconic Design",
    description:
      "Simplicity refined. Our activewear embodies the essence of minimalistic design, delivering effortless style that speaks volumes.",
  },
];
